import React from 'react';

function Header() {
  return (
    <div className="remote-access-dialog__header">
      <h4>Remote access</h4>
    </div>
  );
}

export default Header;
